import { createSlotsContext } from '@grandvisionhq/slots';

const [AppointmentSlotsProvider, useAppointmentSlots] = createSlotsContext({
    displayName: 'AppointmentSlotsContext'
});

export { AppointmentSlotsProvider, useAppointmentSlots };
//# sourceMappingURL=appointment-slots.js.map
